import { createAction } from "@reduxjs/toolkit";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveFundingRequestEligibility = createApiThunk<FundingRequestEligibilityVM, string>(
  "fundingRequests/adminRetrieveFundingRequestEligibility",
  async (studentId: string, { extra: { adminRepository } }) => {
    return adminRepository!.adminFundingRequestEligibility(studentId);
  },
);

export const adminResetRetrieveFundingRequestEligibility = createAction("fundingRequests/adminResetRetrieveFundingRequestEligibility");
